export default __webpack_public_path__ + "static/media/Talisman of Death.9ea74c62.jpg";